<template>
  <div>
    <v-flex class="pb-16">
      <text-field
        v-model.trim="form.replyTo"
        :validator="vs.form.replyTo"
        label="Reply-to e-mail"
      />
    </v-flex>
    <v-flex class="pb-16">
      <select-field
        v-model="form.recipients"
        :validator="vs.form.recipients"
        :items="recipients"
        :disabled="recipients.length === 1"
        label="Recipients*"
      />
    </v-flex>
    <v-flex class="pb-16">
      <v-autocomplete
        v-if="form.recipients == 'Specific categories'"
        ref="catSelect"
        v-model="form.categories"
        v-click-outside="handleClickOutsideCategory"
        :items="categories"
        item-value="id"
        item-text="name"
        label="Categories"
        multiple
        small-chips
        deletable-chips
        @focus="form.attendees = []"
      />
      <v-autocomplete
        v-if="form.recipients == 'Specific attendees'"
        ref="attSelect"
        v-model="form.attendees"
        v-click-outside="handleClickOutsideAttendees"
        :items="attendees"
        item-value="id"
        item-text="name"
        label="Attendees*"
        multiple
        small-chips
        deletable-chips
        @focus="form.categories = []"
      />
    </v-flex>
    <v-flex class="pb-16">
      <text-field v-model.trim="form.subject" :validator="vs.form.subject" label="Subject" />
    </v-flex>
    <v-flex class="pb-16">
      <text-editor-field
        v-model.trim="form.content"
        :validator="vs.form.content"
        label="Content"
        height="390"
        :image-and-code-block-enabled="imageAndCodeBlockEnabled"
      />
    </v-flex>
  </div>
</template>

<script>
import { GET_EVENT_CATEGORIES, GET_EVENT_ACCREDITATIONS_ONLY } from '../../graphql/event.graphql'

export default {
  name: 'create-email-form',
  props: {
    initialValues: {
      type: Object,
      default: () => {},
    },
    vs: {
      type: Object,
      default: () => {},
    },
    eventId: {
      default: null,
      type: String,
    },
    imageAndCodeBlockEnabled: {
      type: Boolean,
      default: false,
    },
    recipients: {
      type: Array,
      default: () => ['All attendees', 'Specific categories', 'Specific attendees'],
    },
  },
  data() {
    return {
      form: [],
      categories: [],
      attendees: [],
      initAttendees: [],
      initCategories: [],
    }
  },
  watch: {
    form: {
      handler(val) {
        if (val.type === 'Automated' && this.recipients.length > 1) {
          if (this.recipients.indexOf('Specific attendees') >= 0) {
            this.recipients.splice(this.recipients.indexOf('Specific attendees'), 1)
          }
        }
        this.$emit('values', val)
      },
      deep: true,
    },
  },
  mounted() {
    const { attendees, categories, ...rest } = this.initialValues
    this.form = rest
    this.form.categories = []
    this.form.attendees = []
    this.initAttendees = attendees || []
    this.initCategories = categories || []
  },
  methods: {
    handleClickOutsideAttendees() {
      this.$refs.attSelect.isMenuActive = false
    },
    handleClickOutsideCategory() {
      this.$refs.catSelect.isMenuActive = false
    },
  },
  apollo: {
    getEventCategories: {
      query: GET_EVENT_CATEGORIES,
      variables() {
        return {
          id: this.eventId,
        }
      },
      result({ data, loading }) {
        if (!loading) {
          const {
            getEventCategories: { categories },
          } = data
          this.categories = categories
          if (this.categories.length) {
            this.categories.map(categorie => {
              if (this.initCategories.includes(categorie.id.toString())) {
                this.form.categories.push(categorie)
              }
            })
          } else {
            if (this.recipients.indexOf('Specific attendees') >= 0) {
              this.recipients.splice(this.recipients.indexOf('Specific categories'), 1)
            }
          }
        }
      },
    },
    getEventAccreditations: {
      query: GET_EVENT_ACCREDITATIONS_ONLY,
      variables() {
        return {
          eventId: this.eventId,
          status: 'ALLOWED',
          quickSearch: '',
          visibleFields: [],
          pagination: { page: 1, per_page: -1 },
          filters: {},
        }
      },
      result({ data, loading }) {
        if (!loading) {
          const {
            getEventAccreditations: { attendees },
          } = data
          this.attendees = attendees.map(function (attendee) {
            return {
              name:
                (attendee.fields['First name'] || attendee.fields['Ime']) +
                ' ' +
                (attendee.fields['Last name'] || attendee.fields['Prezime']),
              ...attendee,
            }
          })
          if (this.initAttendees.length) {
            this.attendees.map(attendee => {
              if (this.initAttendees.includes(attendee.id.toString())) {
                this.form.attendees.push(attendee)
              }
            })
          }
          if (!this.attendees.length && this.recipients.length > 1) {
            if (this.recipients.indexOf('Specific attendees') >= 0) {
              this.recipients.splice(this.recipients.indexOf('Specific attendees'), 1)
            }
          }
        }
      },
    },
  },
}
</script>

<style scoped></style>
